module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_4_2.cecef385.png";